import { vsingleton } from '@niknevis/vue-modules'
import { RemoteData } from '@/modules/shared/helpers/http/remote-data'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'
import { Inertia } from '@/modules/shared/helpers/http/facades/inertia'

import { BootLayoutResource } from '@/modules/common/layout/models/layout-resource.model'
import { UserBootDataResourceModelInAdmin } from '@/modules/user/models/user-resource.model'
import ApiUserRoute from '@/modules/user/routes/api-user.route'

const defaultUser: UserBootDataResourceModelInAdmin = {
  id: 0,
  bot_activation: null,
  username: '',
  display_name: '',
  avatar: '',
  roles: [],
  permissions: [],
  created_at: ''
}

@vsingleton()
export class UserStore {
  constructor(
    private readonly routes: ApiUserRoute
  ) {
  }

  private remoteData = RemoteData.notAsked<BootLayoutResource>()

  get isLoading() {
    return this.remoteData.isInProgress()
  }

  get roles(): string[] {
    return this.remoteData.fold(
      () => [],
      () => [],
      value => value.data.user.roles,
      () => []
    )
  }

  get permissions(): string[] {
    return this.remoteData.fold(
      () => [],
      () => [],
      value => value.data.user.permissions,
      () => []
    )
  }

  get user(): UserBootDataResourceModelInAdmin {
    return this.remoteData.fold(
      () => defaultUser,
      () => defaultUser,
      value => value.data.user,
      () => defaultUser
    )
  }

  getFrontData() {
    if (this.routes.userType) {
      this.remoteData.fromPromise(
        HTTP.get(
          this.routes.boot
        ).then(result => result.json())
      )
    }
  }

  logOut() {
    Inertia.post(
      Ziggy.route('auth.logout').toString()
    )
  }
}
